import { createContext } from 'react';

/**
 * The /demo-table harness's answer to a multi-run vote tap (EN-10856).
 *
 * The demo has no socket, so a real vote would be refused and raise the
 * "taking longer than expected" banner. Inside the harness this context
 * carries a handler that plays the tap forward instead — the panel dismisses,
 * the bubble fills and the table moves on, as it would live. Everywhere else
 * it is null and VoteRunAction sends the vote exactly as it always has.
 *
 * The value is the wire vote ('-2' for 1X, '2', '3'), the same string the
 * real send takes.
 */
export type DemoVoteHandler = (vote: string) => void;

const DemoVoteContext = createContext<DemoVoteHandler | null>(null);

export default DemoVoteContext;
